import React, { useContext, useEffect, useState } from 'react';
import plus from '../dist/webImages/plus.svg';
import SkeletonHeading from '../components/SkeletonHeading';
import SkeletonAuthorsCard from './SkeletonAuthorsCard';
import AuthorsCard from './AuthorsCard';
import { Link } from 'react-router-dom';
import { MainLanguageContext } from '../context/MainLanguageContext';
import useGet from '../customHooks/useGet';
import usePost from '../customHooks/usePost';

const Authors = () => {
  const { mainLanguage } = useContext(MainLanguageContext);
  const [datas, setDatas] = useState([]);
  const [resget, apiMethodGet] = useGet();
  const [searchValue, setSearchValue] = useState('');
  const [res2, apiMethod2] = usePost();

  const fetchAuthors = (search = searchValue) => {
    let formdata = new FormData();
    formdata.append('search_query', search);
    if (search.trim()) {
      apiMethod2(`searchlist/search_author_list/${mainLanguage}`, formdata);
    } else {
      apiMethodGet(`authors/${mainLanguage}`);
    }
  };

  useEffect(() => {
    if (mainLanguage) {
      apiMethodGet(`authors/${mainLanguage}`);
    }
  }, [mainLanguage]);

  useEffect(() => {
    setDatas([]);
    if (!resget.isLoading) {
      setDatas(resget?.data?.data || []);
    }
  }, [resget.data]);

  useEffect(() => {
    setDatas([]);
    if (res2.data) {
      setDatas(res2?.data?.data || []);
    }
  }, [res2.data]);

  let debounceTimer;
  const debounce = (func, delay) => {
    return (...args) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const executeApiCall = (e) => {
    const val = e.target.value;
    setSearchValue(val);
    let formdata = new FormData();
    formdata.append('search_query', val);
    if (val.trim()) {
      apiMethod2(`searchlist/search_author_list/${mainLanguage}`, formdata);
    } else {
      apiMethodGet(`authors/${mainLanguage}`);
    }
  };

  const handleChange = debounce(executeApiCall, 1000);

  const handleDeleted = () => {
    fetchAuthors();
  };

  return (
    <div className='TeamPage pr-10 max-lg:pr-6'>
      <div className='TeamPageTop flex justify-between items-center'>
        {resget.isLoading ? (
          <SkeletonHeading />
        ) : (
          <h6 className='text-[1rem] mb-2 bookingSectionh relative px-3 font-Mluvka'>
            <span>{datas?.length}</span> Authors
          </h6>
        )}
        <div className='flex gap-1'>
          <div className='inputBox w-[16rem] max-lg:hidden'>
            <input
              type='text'
              onChange={handleChange}
              className='w-full border h-[2.8rem] rounded-full px-4 border-[#ddd] outline-none'
              placeholder='Search'
            />
          </div>
          <Link to='/authors/create' className='bg-[#d9dcf8] py-3 px-6 rounded-full flex items-center gap-2 cursor-pointer'>
            <img src={plus} alt='plus' />
            <span className='font-MluvkaBold text-secondary capitalize'>Add new</span>
          </Link>
        </div>
      </div>

      <div className='TeamPageGrid mt-4 bg-[#EFF4FD] rounded-3xl p-6 grid grid-cols-4 gap-3 max-lg:grid-cols-1 max-lg:p-2'>
        {resget.isLoading
          ? Array.from({ length: 8 }).map((_, index) => (
              <SkeletonAuthorsCard key={index} />
            ))
          : Array.isArray(datas) &&
            datas.map((item) => {
              return (
                <AuthorsCard
                  key={item.id}
                  data={item}
                  alldata={datas}
                  deleted={handleDeleted}
                />
              );
            })}
      </div>

    </div>
  );
};

export default Authors;
